import React from 'react';
import { FiCheck, FiClock, FiMoon, FiSun } from 'react-icons/fi';

interface FlowHeaderProps {
  isSaved: boolean;
  lastUpdated?: string;
  lastUpdatedBy?: string;

  theme: 'dark' | 'light';
  onToggleTheme: () => void;
}

export const FlowHeader: React.FC<FlowHeaderProps> = ({
  isSaved,
  lastUpdated,
  lastUpdatedBy,
  theme,
  onToggleTheme,
}) => {
  return (
    <header className="adslot-header">
      <div className="adslot-header-left">
        <h1 className="adslot-header-title">Adsure Creative Testing</h1>
        <span className="adslot-header-separator">–</span>
        <h2 className="adslot-header-subtitle">TV Script Management</h2>
      </div>

      <div className="adslot-header-right">
        <button
          type="button"
          className="adslot-btn adslot-btn-outline adslot-btn-sm"
          onClick={onToggleTheme}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
        >
          {theme === 'dark' ? <FiSun /> : <FiMoon />}
          {theme === 'dark' ? 'Light' : 'Dark'}
        </button>

        {isSaved ? (
          <div className="adslot-header-status adslot-header-status-success">
            <FiCheck className="adslot-icon-xs" />
            <span>Saved</span>
          </div>
        ) : (
          <div className="adslot-header-status adslot-header-status-warning">
            <FiClock className="adslot-icon-xs" />
            <span>Unsaved changes</span>
          </div>
        )}

        {lastUpdated && (
          <span className="adslot-header-updated">
            Last updated: {lastUpdated}
            {lastUpdatedBy && ` · by ${lastUpdatedBy}`}
          </span>
        )}
      </div>
    </header>
  );
};
